<template>
  <div>
    <q-dialog v-model="show" persistent
    :style="`width: ${modalWidth}; height: ${modalHeight}; max-width: none; max-height: none;`"
    @input="() => {
      this.currentStep = 0
      $emit('input', false)
      }">
      <div class="tw-flex tw-flex-col modal-medium">
        <q-layout view="Lhh lpR fff" container class="bg-white tw-flex-1 tw-overflow-hidden">
          <q-header class="bg-primary">
          <q-toolbar>
            <q-toolbar-title>{{
              $gettext("NEGOTIATION_TITLE_MODAL")
            }}</q-toolbar-title>
            <q-btn v-close-popup flat round dense icon="close" />
          </q-toolbar>
        </q-header>
        <q-page-container class="tw-overflow-hidden">
          <q-stepper
            animated
            v-model="currentStep"
            ref="stepper"
            color="primary"
          >
            <q-step
              :name="0"
              :title="$gettext('SLECTED_INVOICES')"
            >
             <invoice-selected-negotiation-steep
              @hideModal="hideModal"
              />
            </q-step>
            <q-step :name="1" :title="$gettext('NEGOTIATION')">
              <negotiation-form-steep @handleDisabledContinue="(e)=>{}"/>
            </q-step>
            <q-step :name="2" :title="$gettext('INSTALLMENT_INVOICES')">
              <detail-installment-steep/>
            </q-step>
            <q-step :name="3" :title="$gettext('RESPONSIBLE')">
              <responsible-form-steep
                :protocol="protocol"
                :consumer-unit="consumerUnit"
              />
            </q-step>
            <q-step :name="lastStep" :title="$gettext('NEGOTIATION_TERM')">
              <terms-steep :consumerUnit="consumerUnit"/>
            </q-step>
          </q-stepper>
        </q-page-container>
      </q-layout>
      <footer class="tw-w-full tw-p-4 tw-bg-white">
          <div class="tw-flex tw-justify-center tw-gap-4">
            <q-btn
              class="tw-w-1/5"
              :label="isFirstStep ? $gettext('CANCEL') : $gettext('BACK')"
              color="grey-7"
              @click="onCancelClick"
            />
            <q-btn
              class="tw-w-1/5"
              :label="isLastStep ? $gettext('PARCEL') : $gettext('CONTINUE')"
              :color="isDisabledContinueButton?'grey-7':'info'"
              @click="onContinue"
              :disable="isDisabledContinueButton"
            />
          </div>
        </footer>
      </div>
    </q-dialog>
    <JtDocsViewer
      :src="fileSrc"
      :title="$gettext('NEGOTIATION_TERM')"
      pdf
      ref="reportModal"
      v-on:hide="() => hideModal()"
    />
  </div>
</template>
<script>
import { Component, Vue } from 'vue-property-decorator'
import { JtInput, JtDocs } from 'jtech-webcomps'
import InvoiceSelectedNegotiationSteep from './stepps-modal/InvoiceSelectedNegotiationSteep.vue'
import NegotiationFormSteep from './stepps-modal/NegotiationFormSteep.vue'
import DetailInstallmentSteep from './stepps-modal/DetailInstallmentSteep.vue'
import ResponsibleFormSteep from './stepps-modal/ResponsibleFormSteep.vue'
import TermsSteep from './stepps-modal/TesmsSteep.vue'
import NegotiationController from './NegotiationController'
const { JtDocsViewer } = JtDocs
import ServiceRequestController from 'src/modules/concession/service-request/ServiceRequestController'
@Component({
  name: 'NegotiationModal',
  components: {
    JtInput,
    InvoiceSelectedNegotiationSteep,
    NegotiationFormSteep,
    DetailInstallmentSteep,
    ResponsibleFormSteep,
    TermsSteep,
    JtDocsViewer
  },
  props: {
    consumerUnit: String,
    protocol: String,
    show: {
      type: Boolean,
      default: false
    },
    modalWidth: { type: String, default: '200vw' },
    modalHeight: { type: String, default: '100vh' }
  }
})
class NegotiationModal extends Vue {
  negotiationController = NegotiationController.getInstance();
  controller = ServiceRequestController.getInstance();
  fileSrc = null
  lastStep = 4;
  currentStep = 0;
  isDisabledContinue = false

  get isDisabledContinueButton () {
    return this.negotiationController.getDisabledContinue()
  }

  get isFirstStep () {
    return this.currentStep === 0
  }

  get isLastStep () {
    return this.currentStep === this.lastStep
  }

  onCancelClick () {
    if (this.isFirstStep) {
      this.hideModal()
    } else {
      this.currentStep -= 1
    }
    this.negotiationController.setDisabledContinue(false)
  }

  onContinue () {
    if (this.isLastStep) {
      this.saveNegotiation()
    } else {
      this.currentStep += 1
    }
  }

  async saveNegotiation () {
    const pdf = await this.negotiationController.saveNegotiation(
      this.controller.state.serviceRequests[this.protocol].clientID,
      this.controller.state.serviceRequests[this.protocol].consumerUnits[this.consumerUnit].id)
    this.currentStep = 0
    await this.__whenGenerationFormatIsOnline({ nmArquivo: pdf })
  }

  async __whenGenerationFormatIsOnline ({ nmArquivo }) {
    try {
      const result = await this.$jt.repository.downloadFile(
        nmArquivo,
        'pdf',
        '',
        'application/pdf'
      )

      this.fileSrc = URL.createObjectURL(result)
      this.$nextTick(() => {
        this.$refs.reportModal.show()
      })
      return Promise.resolve()
    } catch (error) {
      return Promise.reject(error)
    }
  }

  hideModal () {
    this.currentStep = 0
    this.$emit('input', false)
  }
}

export default NegotiationModal
</script>
<style lang="scss" scoped>
@import "tailwindcss/utilities";

.q-dialog__inner > div {
  max-width: none !important;
  max-height: none !important;
}
</style>
